import { h, Component, createRef } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

const debug = false;
const debugName = 'Images';

@observer
class DragNDropFileupload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drag: false,
            loadingProgress: 0,
            uploadedFiles: [],
            uploadedFilesData: {},
        };
    }

    dropRef = createRef();

    handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            this.setState({ drag: true });
        }
    }

    handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({ drag: false });
        }
    }

    handleDrop = (e) => {
        if (debug) {
            console.log(`${debugName}.handleDrop: event`, e);
        }
        e.preventDefault();
        e.stopPropagation();
        this.setState({ drag: false });
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // this.props.handleDrop(e.dataTransfer.files);
            // e.dataTransfer.clearData();
            for (let i = 0, l = e.dataTransfer.files.length; i < l; i += 1) {
                const photo = e.dataTransfer.files[i];
                // if (photo.type.match('image.*')) {
                this.readLocalFile(photo);
                // }
            }
            this.dragCounter = 0;
        }
    }

    // Upload
    handleAddFiles = (event) => {
        event.preventDefault();
        const el = event.target;
        if (debug) {
            console.log(`${debugName}.handleAddFiles: event, el`, event, el);
        }
        for (let i = 0, l = el.files.length; i < l; i += 1) {
            const photo = el.files[i];
            // if (photo.type.match('image.*')) {
            this.readLocalFile(photo);
            // }
        }
    }

    handleEvent = (e, fileObject) => {
        if (debug) {
            console.log(`${debugName}.handleEvent[${fileObject.name}]: ${e.type}: `
                + `${e.loaded} bytes transferred of ${e.total}. Is lengthComputable: ${e.lengthComputable}: `
                + `${JSON.stringify(e)}`);
        }
    }

    handleUpload = (fileObject) => {
        if (debug) {
            console.log(`${debugName}.handleUpload[${fileObject.name}]`);
        }
        const formData = new FormData();
        formData.append('files[]', fileObject);
        const uploadMeta = {
            progress: 1,
        };

        uploadMeta.xhr = new XMLHttpRequest();

        uploadMeta.xhr.upload.addEventListener('progress', (event) => {
            const fileObj = fileObject;
            this.updateProgress(event, fileObj);
        });
        uploadMeta.xhr.addEventListener('loadstart', (event) => {
            const fileObj = fileObject;
            this.handleEvent(event, fileObj);
        });
        uploadMeta.xhr.addEventListener('load', (event) => {
            const fileObj = fileObject;
            this.handleEvent(event, fileObj);
        });
        uploadMeta.xhr.addEventListener('loadend', (event) => {
            const fileObj = fileObject;
            this.handleEvent(event, fileObj);
        });
        uploadMeta.xhr.addEventListener('progress', (event) => {
            const fileObj = fileObject;
            this.handleEvent(event, fileObj);
        });
        uploadMeta.xhr.addEventListener('error', (event) => {
            const fileObj = fileObject;
            this.handleEvent(event, fileObj);
        });
        uploadMeta.xhr.addEventListener('abort', (event) => {
            const fileObj = fileObject;
            this.handleEvent(event, fileObj);
        });
        uploadMeta.xhr.addEventListener('readystatechange', (event) => {
            const fileObj = fileObject;
            this.uploadDone(event, fileObj);
        });

        uploadMeta.xhr.open('POST', `${util.getApiServer()}${this.props.apiUrl}`);
        uploadMeta.xhr.setRequestHeader('Authorization', `Bearer ${util.getJwtToken()}`);
        uploadMeta.xhr.send(formData);

        const filename = fileObject.name;
        const uploadedFilesData = this.state.uploadedFilesData;
        if (!uploadedFilesData[filename]) {
            uploadedFilesData[filename] = {};
        }
        uploadedFilesData[filename].uploadMeta = uploadMeta;
        uploadedFilesData[filename].imageNum = this.state.imageNum;
        this.setState({ uploadedFilesData });
    }

    // eslint-disable-next-line
    readLocalFile = (fileObject) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.addEventListener('error', (error) => {
                if (debug) {
                    console.log(`${debugName}.FileReader: Error occurred reading file: ${fileObject.name}: ${error}`);
                }
                reject(error);
            });

            reader.addEventListener('load', (event) => {
                if (debug) {
                    console.log(`${debugName}.FileReader: File: ${fileObject.name} read successfully: `
                        + `${JSON.stringify(event)}`);
                }
                const photo = fileObject;
                const filename = photo.name;
                const uploadedFilesData = this.state.uploadedFilesData;
                if (!uploadedFilesData[filename]) {
                    uploadedFilesData[filename] = {};
                }
                uploadedFilesData[filename].event = event;
                this.setState({ uploadedFilesData });
                this.handleUpload(photo);
                resolve(event);
            });

            reader.readAsDataURL(fileObject);
        });
    }

    updateProgress = (event, fileObject) => {
        if (event.lengthComputable) {
            const filename = fileObject.name;
            const uploadedFilesData = this.state.uploadedFilesData;
            const percentComplete = (event.loaded / event.total) * 100;
            if (debug) {
                console.log(`${debugName}.updateProgress[${filename}].progress`, percentComplete);
            }
            uploadedFilesData[filename].uploadMeta.progress = percentComplete;
            this.setState({ uploadedFilesData });
        }
    }

    uploadDone = (event, fileObject) => {
        const filename = fileObject.name;
        const uploadedFilesData = this.state.uploadedFilesData;
        const uploadMeta = uploadedFilesData[filename].uploadMeta;
        if (debug) {
            console.log(`${debugName}.uploadDone[${filename}].uploadedFilesData`, uploadedFilesData);
            console.log(`${debugName}.uploadDone[${filename}].uploadMeta`, uploadMeta);
            console.log(`${debugName}.uploadDone.event`, event);
        }

        if (uploadMeta && uploadMeta.xhr.readyState === 4 && uploadMeta.xhr.status === 201) {
            const response = JSON.parse(uploadMeta.xhr.responseText);
            const files = response.data.files;
            for (let i = 0; i < files.length; i += 1) {
                const file = files[i];
                this.addFileToUpload(file);
                this.fileInput.value = '';
            }
        }
    }

    addFileToUpload(file) {
        if (debug) {
            console.log(`${debugName}.addFileToUpload[${file.name}]`);
        }
        const { uploadedFilesData } = this.state;
        const { handleAddImage } = this.props;

        delete uploadedFilesData[file.name];
        this.setState({ uploadedFilesData });
        handleAddImage(file);
    }
    // /Upload

    componentDidMount() {
        const div = this.dropRef.current;
        div.addEventListener('dragenter', this.handleDragIn);
        div.addEventListener('dragleave', this.handleDragOut);
        div.addEventListener('dragover', this.handleDrag);
        div.addEventListener('drop', this.handleDrop);
    }

    componentWillUnmount() {
        const div = this.dropRef.current;
        div.removeEventListener('dragenter', this.handleDragIn);
        div.removeEventListener('dragleave', this.handleDragOut);
        div.removeEventListener('dragover', this.handleDrag);
        div.removeEventListener('drop', this.handleDrop);
    }

    render() {
        const { uploadedFilesData } = this.state;

        return (
            <div style={{ position: 'relative' }} ref={this.dropRef}>
                {this.state.drag &&
                <div style={{
                    border: 'dashed grey 4px',
                    backgroundColor: 'rgba(255,255,255,.8)',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            right: 0,
                            left: 0,
                            textAlign: 'center',
                            color: 'grey',
                            fontSize: 36,
                        }}
                    >
                        <div>drop your files here :)</div>
                    </div>
                </div>}

                <div>
                    <input class='btn btn-info col-sm-12' multiple
                        type='file'
                        id='image-file'
                        onchange={this.handleAddFiles}
                        ref={(c) => {
                            this.fileInput = c;
                        }}
                    />
                </div>
                <div>
                    {Object.keys(uploadedFilesData).length > 0 ? (<h3>Uploaded images</h3>) : ''}
                    <ul class='list-group'>
                        {Object.keys(uploadedFilesData).map((key) => {
                            const { uploadMeta = {} } = uploadedFilesData[key];
                            const isImage = key.match(/(jpg|jpeg|png|gif)/i);
                            return (
                                <li class='list-group-item list-group-item-action flex-column align-items-start'>
                                    <div class='d-flex w-100 justify-content-between'>
                                        <span class='mb-1'>{key}</span>
                                        <small>{util.formatBytes(uploadedFilesData[key].event.total, 2)}</small>
                                    </div>
                                    <div class='d-flex w-100 justify-content-between'>
                                        {isImage && <img class='img-fluid mr-3'
                                            src={uploadedFilesData[key].event.target.result}
                                            style='max-height: 150px;'
                                        />}
                                        <small>{uploadedFilesData[key].event.uploadDone}</small>
                                        Uploading, please wait...
                                    </div>
                                    <div class='progress' style='height: 2px;'>
                                        <div
                                            class='progress-bar progress-bar-striped progress-bar-animated bg-success'
                                            role='progressbar'
                                            style={`width: ${uploadMeta.progress}%; height: 2px;`}
                                            aria-valuenow={uploadMeta.progress}
                                            aria-valuemin='0'
                                            aria-valuemax='100'
                                        />
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>

                {this.props.children}
            </div>
        );
    }
}

export default DragNDropFileupload;



// WEBPACK FOOTER //
// ./components/form/dragNdropFileupload.js